import { render } from "./ArtistDetail.vue?vue&type=template&id=2693b1dd"
import script from "./ArtistDetail.vue?vue&type=script&lang=js"
export * from "./ArtistDetail.vue?vue&type=script&lang=js"

import "./ArtistDetail.vue?vue&type=style&index=0&id=2693b1dd&lang=scss"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__